<template>
  <v-select
      v-model="item"
      :items="items"
      :label="itemAction.name"
      :item-text="itemText"
      :item-value="(itemAction.itemValue) ? itemAction.itemValue : 'id'"
      clearable
      outlined
      dense>
        <template v-slot:selection="{item}">
          <span class="font-weight-bold">
             {{ itemText(item) }}
          </span>
        </template>
        <template v-slot:item="{ item }">
            <template v-if="item.padre_id == 0">
              <v-list-item-content>
                <span class="font-weight-bold subtitle-1">{{ itemText(item) }}</span>
              </v-list-item-content>
            </template>
            <template v-else>
              <v-list-item-content class="pl-4">
                {{ itemText(item) }}
              </v-list-item-content>
            </template>
        </template>
  </v-select>
</template>

<script>
import axios from 'axios'
export default {
  props: ['itemAction', 'onSuccess', 'setterModel'],
  data: () => ({
    item: null,
    items: []
  }),
  created () {
    if (this.itemAction.url) {
      this.getDinamicData(this.itemAction.url)
    }
  },
  methods: {
    itemText (item) {
      if (item && this.itemAction.nameid === 'familiaId') {
        return `${item.nombre}`
      } else {
        return `${item.nombre}`
      }
    },
    getDinamicData (url) {
      const token = this.$cookies.get('token')
      const params = (this.itemAction.params) ? this.itemAction.params : ''
      axios.get(`${url}${params}`, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
        this.items = []
        this.items.push(...response.data)
        // this.setModel(this.items)
      }).catch(error => {
        if (error == null) {}
      })
    },
    setModel (vals) {
      vals.map(i => {
        if (this.setterModel === i.id) {
          this.item = i
        }
      })
    }
  },
  computed: {
  },
  watch: {
    item (val) {
      if (val) {
        this.onSuccess({ id: this.itemAction.nameid, data: val })
      } else {
        this.onSuccess(val)
      }
    },
    items (vals) {
      if (this.setterModel) {
        this.item = this.setterModel
      }
    }
  }
}
</script>

<style>

</style>
